<template>
	<div class="calendar-plug" ref="calendar">

		<div class="top">

			<div>
				<van-icon name="arrow-left" class="arrow-icon" @click="lastMonthClick"
					:style="{ color: calendar_active == 0 ? '#901D22' : '', backgroundColor: calendar_active == 1 ? '#F3F3F3' : '#FFE6E7' }" />
				<!-- <van-icon name="arrow" class="arrow-icon" @click="nextMonthClick"
					:style="{ color: calendar_active == 1 ? '#901D22' : '', backgroundColor: calendar_active == 0 ? '#F3F3F3' : '#FFE6E7', 'margin-left': '10px' }" /> -->
			</div>
			<!-- <img src="@/assets/images/riqi.png" @click="showCalendarDialog" /> -->
			<span class="date" @click="showCalendarDialog">{{ selectedYear }}年{{ selectedMonth > 9 ? selectedMonth : '0' + selectedMonth }}月</span>
			<div>
				<!-- <van-icon name="arrow-left" class="arrow-icon" @click="lastMonthClick"
					:style="{ color: calendar_active == 0 ? '#901D22' : '', backgroundColor: calendar_active == 1 ? '#F3F3F3' : '#FFE6E7' }" /> -->
				<van-icon name="arrow" class="arrow-icon" @click="nextMonthClick"
					:style="{ color: calendar_active == 1 ? '#901D22' : '', backgroundColor: calendar_active == 0 ? '#F3F3F3' : '#FFE6E7' }" />
			</div>
			<div class="search">
				<img src="@/assets/images/icon_search.png" @click="goSearch" />

			</div>
		</div>
		<div class="container">
			<div class="everyDay">
				<div class="weekDay">
					<van-row type="flex" justify="space-between">
						<van-col span="3" v-for="(item, index) in weekDays" :key="index">{{ item }}</van-col>
					</van-row>
				</div>
				<div v-for="(value, week_index) in groupByWeekArr" :key="week_index" class="every-week">
					<!-- <div class="flex day-number">
							<div style="background:#ECF3FF" class="day-number-flex"  v-for="(item,index) in value.number" :key="index">{{item}}</div>
						</div> -->
					<van-row type="flex" justify="space-between" class="day-number">
						<van-col span="3" v-for="(item, index) in value.number" :key="index"
							:class="item == currentDay && selectedMonth == currentMonth && selectedYear == currentYear ? 'today-number' : (item == selectedDay.day ? 'choose-day' : '')"
							@click="selectDate(item)">{{ item }}</van-col>
					</van-row>
					<van-row type="flex" justify="space-between" class="every-meeting"
						v-for="(meeting, index) in meetingsByWeek" :key="index">
						<van-col v-if="meeting.week_number == week_index" :span="Math.round(meeting.offset)">
						</van-col>
						<van-col v-if="meeting.week_number == week_index" :span="Math.round(meeting.day_count)"
							:style="{ background: backgroundColor[meeting.color_index % 5], 'border-radius': '5px' }"
							class="line-1" @click="showDetail(meeting.color_index)">
							{{ meeting.title }}
						</van-col>
						<van-col v-if="meeting.week_number == week_index"
							:span="24 - Math.round(meeting.offset) - Math.round(meeting.day_count)">
						</van-col>
					</van-row>
				</div>
			</div>
		</div>
		<van-popup v-model="show" position="bottom" round closeable>
			<h2>会议</h2>
			<div class="detail-item" @click="goDetail(detailInfo.id, detailInfo.buttons_count)">
				<span class="color-line" :style="{ 'background-color': backgroundColor[color_index] }"></span>
				<div class="content">
					<div class="name">{{ detailInfo.name }}</div>
					<div>
						<p v-if="detailInfo.city">地点：{{ detailInfo.province + " " + detailInfo.city }}
						</p>
						<p v-else>地点：{{ detailInfo.province }}</p>
						<p>{{ detailInfo.start_at }}-{{ detailInfo.end_at }}</p>
					</div>

				</div>
				<div class="image">
					<img :src="detailInfo.banner" />
				</div>
			</div>
		</van-popup>
		<van-popup v-model="chooseDateFlag" position="bottom" round>
			<van-datetime-picker v-model="currentDate" type="year-month" title="选择年月" :formatter="formatter"
				@confirm="confirmDate" @cancel="chooseDateFlag = false" />
		</van-popup>
	</div>
</template>
<script>
export default {
	data() {
		return {
			calendar_active: 1,
			currentYear: new Date().getFullYear(),      //当前年
			currentMonth: new Date().getMonth() + 1,        //当前月
			currentDay: new Date().getDate(),           //代表今天
			currentWeekday: new Date().getDay(),       //今天周几
			currentDate: new Date(),
			defaultWeekday: '',                        //每个月1号对应的周几
			dayCount: 0,            //这个月的天数
			// weekdayCount:0,        //这个周有几天
			lastMonthDay: 0,
			weekDays: ["一", "二", "三", "四", "五", "六", "日"],
			months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
			lastDays: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
			selectedYear: '',      //选中的年份
			selectedMonth: '',     //选中的月份
			selectedDay: {},       //选中的日期
			dateArr: [],
			monthMeetings: [],      //本月会议
			monthMeetingsDate: [],       //本月会议日期
			backgroundColor: ['#4B85ED', '#FDA245', '#57C393', '#FF8288', '#C783FC'],
			bgColor: ['#ECF3FF', '#FFF4EA', '#DDF6EB', '#FFEDEE', '#F8EEFF'],
			groupByWeekArr: [], //本月日期 一周一组
			meetingsByWeek: [],
			show: false,
			detailInfo: {},
			color_index: 0,
			chooseDateFlag: false
		}
	},

	mounted() {
		this.selectedYear = this.currentYear;
		this.selectedMonth = this.currentMonth;
		this.selectedDay = {
			year: this.currentYear,
			month: this.currentMonth,
			day: this.currentDay
		}
		this.getThisMonthDay(this.selectedYear, this.selectedMonth);
		this.getThisWeekDay(this.selectedYear, this.selectedMonth, 1);
	},
	methods: {
		//初始化
		init(data) {
			this.monthMeetingsDate = [];
			this.monthMeetings = data;
			let length = 0;
			for (let j = 0; j < data.length; j++) {
				let str1 = data[j].start_at;
				let str2 = data[j].end_at;
				let arr1 = this.dataScope(str1, str2);
				let arr2 = {
					name: data[j].calendar_title,
					date: [],
					id: data[j].id,
					buttons_count: data[j].buttons_count
				};
				for (let j = 0; j < arr1.length; j++) {
					let dateArr = arr1[j].split('-');
					let date = new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
					if (this.selectedMonth == date.getMonth() + 1 && this.selectedYear == date.getFullYear()) {
						arr2.date.push(date.getDate())
					}
				}
				this.monthMeetingsDate.push(arr2);

			}

			this.monthMeetingsDate.sort(function (a, b) {
				return b.date.length - a.date.length;
			})
			this.groupByWeek();
			this.meetingGroupByWeek();
		},
		//时间段内对应的日期
		dataScope(value1, value2) {
			var date1 = new Date(value1).getTime();
			var date2 = new Date(value2).getTime();
			if (date1 > date2) {
				var tempDate = date1;
				date1 = date2;
				date2 = tempDate;
			}
			var dateArr = [];
			var i = 0;

			while (date1 <= date2) {
				date1 = new Date(date1);
				var dayStr = date1.getDate().toString();
				if (dayStr.length == 1) {
					dayStr = "0" + dayStr;
				}
				dateArr[i] = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-"
					+ dayStr;
				i++;

				date1.setDate(date1.getDate() + 1);
			}
			return dateArr;
		},
		//选择日期
		selectDate(day) {
			this.selectedDay = {
				year: this.selectedYear,
				month: this.selectedMonth,
				day: day
			}
			let date = this.selectedDay
			date.month = date.month < 10 ? '0' + date.month : date.month;
			date.day = date.day < 10 ? '0' + date.day : date.day;
			this.$emit('changeDay', date.year + '-' + date.month + '-' + date.day)
		},
		//判断是否是闰年
		isLeapYear: function (year) {
			if (0 == year % 4 && ((year % 100 != 0) || (year % 400 == 0))) {
				return true
			}
			return false;
		},
		//得到这个月的天数
		getThisMonthDay: function (year, month) {
			var dayCount = this.lastDays[month - 1];
			this.lastMonthDay = this.lastDays[month - 2];       //上个月的天数
			if ((month == 2) && this.isLeapYear(year)) {
				dayCount++;
			}
			this.dayCount = dayCount;
			let dateArr = [];
			for (let i = 1; i <= dayCount; i++) {
				let obj = {};
				obj.solar = i;
				obj.month = month;
				obj.year = year;
				dateArr.push(obj);
			}
			this.dateArr = dateArr;
		},
		//得到上个月的天数
		getLastMonthDay(year, month) {
			var dayCount = this.lastDays[month - 2];
			this.lastMonthDay = dayCount;
		},
		//得到周几(一般得到每个月1号是周几)
		getThisWeekDay: function (year, month, date) {
			var thisDate = new Date(year, month - 1, date - 1);
			this.defaultWeekday = thisDate.getDay();
		},
		//切换上个月
		lastMonthClick() {
			this.calendar_active = 0;
			this.monthMeetingsDate = [];    //将数据清空  以防数据变动  出现闪
			if (this.selectedMonth == 1) {
				this.selectedYear--;
				this.selectedMonth = 12;
			} else {
				this.selectedMonth--;
			}
			this.reloadData();
		},
		//切换下一个月
		nextMonthClick() {
			this.calendar_active = 1;
			this.monthMeetingsDate = [];   //将数据清空  以防数据变动  出现闪
			if (this.selectedMonth == 12) {
				this.selectedYear++;
				this.selectedMonth = 1;
			} else {
				this.selectedMonth++;
			}
			this.reloadData();
		},

		//重新刷新数据
		reloadData() {
			this.getThisMonthDay(this.selectedYear, this.selectedMonth);
			this.getThisWeekDay(this.selectedYear, this.selectedMonth, 1);
			this.$emit('changeMonth', this.selectedMonth, this.selectedYear)
		},
		cumWeekDayCounrt: function (date) {
			var thisDate = new Date(this.selectedYear, this.selectedMonth - 1, date);
			return thisDate.getDay();
		},
		//按周分日期
		groupByWeek() {
			let first = { number: [] };
			if (this.defaultWeekday > 0) {
				for (let i = 0; i < this.defaultWeekday; i++) {
					first.number.push('')
				}
			}
			if (7 - this.defaultWeekday > 0) {
				for (let i = 1; i <= 7 - this.defaultWeekday; i++) {
					first.number.push(i)
				}
			}
			this.groupByWeekArr = [];
			this.groupByWeekArr.push(first);
			let lastDay = 0;
			for (let i = 0; i < (this.dayCount - (7 - this.defaultWeekday)) / 7 - 1; i++) {
				let week = { number: [] };
				for (let j = 0; j < 7; j++) {
					week.number.push(7 - this.defaultWeekday + i * 7 + j + 1);
				}
				lastDay = 7 - this.defaultWeekday + i * 7 + 7;
				this.groupByWeekArr.push(week);
			}
			if (this.dayCount - lastDay > 0) {
				let week = { number: [] }
				for (let i = lastDay + 1; i < this.dayCount + 1; i++) {
					week.number.push(i);
				}
				for (let i = 0; i < 7 - (this.dayCount - lastDay); i++) {
					week.number.push('');
				}
				this.groupByWeekArr.push(week);
			}
		},
		//显示弹框跳出详情
		showDetail(index) {
			this.show = true
			let obj = this.monthMeetings[index]
			obj['start_at'] = obj.start_at.split('-').join('.')
			obj['end_at'] = obj.end_at.split('-').join('.').substring(5)

			this.detailInfo = obj
			// this.$set(this.detailInfo,this.monthMeetings[index])
			this.color_index = index
		},
		//跳转
		goDetail(id, buttons_count) {
			if (id == 286) {
				this.$router.push({
					path: '/CEC2022/index',
				})
				return
			}
			else if (id == 348) {
				this.$router.push({
					path: '/CEC2023/index',
				})
				return
			}
			else if (id == 399) {
				this.$router.push({
					path: '/CVSCF2023/index'
				})
				return
			}
			else if (id == 483) {
				this.$router.push({
					path: '/XVC/index'
				})
				return
			}
			if (buttons_count) {
				this.$router.push({
					path: '/vascularNews/meeting/index',
					query: {
						meeting_id: id,
					}
				})
			}
			else {
				this.$router.push({
					path: '/vascularNews/meeting/live',
					query: {
						meeting_id: id,
					}
				})
			}

		},
		//按周分会议
		meetingGroupByWeek() {
			//判断是这个月第几个星期的 推到groupByWeekArr这个数组中
			let meetingsWeek = [];
			this.monthMeetingsDate.forEach((item, index) => {
				let week_number = parseInt((item.date[0] + this.defaultWeekday - 1) / 7); //第一行在第几个礼拜显示
				let color_index = index;
				for (let i = 0; i < this.monthMeetings.length; i++) {
					if (item.id == this.monthMeetings[i].id) {
						color_index = i;
						break;
					}
				}
				//设置颜色index  偏移数量 天数数量
				//如果不止一个礼拜有
				if ((item.date[0] + this.defaultWeekday - 1) % 7 + item.date.length > 7) {
					let week_count = parseInt((((item.date[0] + this.defaultWeekday - 1) % 7 + item.date.length) - 1) / 7 + 1);
					if (week_count == 2) {
						let dict = {
							week_number: week_number,
							color_index: color_index,
							offset: (item.date[0] - 1 + this.defaultWeekday) % 7 * 3.4,
							day_count: 7 - (item.date[0] - 1 + this.defaultWeekday) % 7 * 3.4,
							title: item.name,
							id: item.id,
							buttons_count: item.buttons_count
						}
						meetingsWeek.push(dict);
						dict = {
							week_number: week_number + 1,
							color_index: color_index,
							offset: 0,
							day_count: (item.date.length - (7 - (item.date[0] - 1 + this.defaultWeekday) % 7)) * 3.4,
							title: item.name,
							id: item.id,
							buttons_count: item.buttons_count
						}
						meetingsWeek.push(dict)
					}
					else {
						if (week_count == 3) {
							let dict = {
								week_number: week_number,
								color_index: color_index,
								offset: (item.date[0] - 1 + this.defaultWeekday) % 7 * 3.4,
								day_count: 7 - (item.date[0] - 1 + this.defaultWeekday) % 7 * 3.4,
								title: item.name,
								id: item.id,
								buttons_count: item.buttons_count
							}


							meetingsWeek.push(dict);
							dict = {
								week_number: week_number + 1,
								color_index: color_index,
								offset: 0,
								day_count: 7 * 3.4,
								title: item.name,
								id: item.id,
								buttons_count: item.buttons_count
							}
							meetingsWeek.push(dict)
							dict = {
								week_number: week_number + 2,
								color_index: color_index,
								offset: 0,
								day_count: (item.date.length - (14 - (item.date[0] - 1 + this.defaultWeekday) % 7)) * 3.4,
								title: item.name,
								id: item.id,
								buttons_count: item.buttons_count
							}
							meetingsWeek.push(dict)
						}
						else {
							if (week_count == 4) {
								let dict = {
									week_number: week_number,
									color_index: color_index,
									offset: (item.date[0] - 1 + this.defaultWeekday) % 7 * 3.4,
									day_count: (7 - (item.date[0] - 1 + this.defaultWeekday) % 7) * 3.4,
									title: item.name,
									id: item.id,
									buttons_count: item.buttons_count
								}
								meetingsWeek.push(dict);
								dict = {
									week_number: week_number + 1,
									color_index: color_index,
									offset: 0,
									day_count: 7 * 3.4,
									title: item.name,
									id: item.id,
									buttons_count: item.buttons_count
								}
								meetingsWeek.push(dict)
								dict = {
									week_number: week_number + 2,
									color_index: color_index,
									offset: 0,
									day_count: 7 * 3.4,
									title: item.name,
									id: item.id,
									buttons_count: item.buttons_count
								}
								meetingsWeek.push(dict)
								dict = {
									week_number: week_number + 3,
									color_index: color_index,
									offset: 0,
									day_count: (item.date.length - (21 - (item.date[0] - 1 + this.defaultWeekday) % 7)) * 3.4,
									title: item.name,
									id: item.id,
									buttons_count: item.buttons_count
								}
								meetingsWeek.push(dict)
							}

						}
					}
				}
				//如果是一个礼拜中的
				else {
					let dict = {
						week_number: week_number,
						color_index: color_index,
						offset: (item.date[0] - 1 + this.defaultWeekday) % 7 * 3.4,
						day_count: item.date.length * 3.4,
						title: item.name,
						id: item.id,
						buttons_count: item.buttons_count
					}
					meetingsWeek.push(dict)
				}
			})
			this.meetingsByWeek = meetingsWeek;
			// console.log(this.meetingsByWeek)
		},
		showCalendarDialog() {
			this.chooseDateFlag = true
		},
		formatter(type, val) {
			if (type === 'year') {
				return `${val}年`;
			} else if (type === 'month') {
				return `${val}月`;
			}
			return val;
		},
		confirmDate(value) {
			this.chooseDateFlag = false;
			if (this.selectedYear != value.getFullYear() || this.selectedMonth != (value.getMonth() + 1)) {
				this.monthMeetingsDate = [];   //将数据清空  以防数据变动  出现闪
				this.selectedYear = value.getFullYear();
				this.selectedMonth = value.getMonth() + 1
				this.reloadData();
			}
		},
		goSearch() {
			// if(this.keywords){
			this.$router.push({
				path: '/vascularNews/search',
				query: {
					keywords: this.keywords
				}
			})
			// }
		}

	}
}
</script>
<style lang="scss" scoped>
.calendar-plug {
	background: white;
	padding: 0 15px;

	.top {
		transform: perspective(1000);
		// background:#ededed;
		padding: 14px 0;
		@include flex(row);
		// justify-content: space-between;
		justify-content: center;
		align-items: center;
		position: relative;

		img {
			width: 20px;
			height: 20px;
		}

		i {
			font-size: 16px;
			border-radius: 5px;
			opacity: 1;
			background: #F3F3F3;
			color: #999999;
			width: 26px;
			height: 26px;
			line-height: 26px;
			text-align: center;
		}

		span.date {
			color: #141414;
			letter-spacing: 0.5px;
			font-size: 16px;
			font-weight: normal;
			line-height: 19px;
			border: 0.5px solid #E8E8E8;
			border-radius: 5px;
			padding: 0 15px;
			margin: 0 10px;
		}
	}

	.search {
		position: absolute;
		width: 30px;
		height: 30px;
		// background: #901D22;
		text-align: center;
		line-height: 30px;
		border-radius: 50%;
		right: 0;

		img{
			width: 100%;
			height: 100%;
		}

	}

	.container {
		margin: 0 -10px;

		.everyDay {
			.weekDay {
				text-align: center;
				font-size: 16px;
				color: #666666;
				border-radius: 10px 10px 0px 0px;
				background: #FFFFFF;
				border: 0.5px solid #E8E8E8;
				padding: 10px 0;
			}

			.today-number {
				color: #901D22;
			}

			.today-number::before {
				content: '.';
				color: #901D22;
				position: relative;
				top: 0;
				display: block;
				margin-top: -12px;
				line-height: 12px;
			}

			.choose-day {
				color: #204EA1;
			}

			.every-week {
				// min-height:60px;
				text-align: center;
				padding: 10px 0 10px;

				.day-number {
					font-size: 16px;
					color: #7D7D7D;
				}

				.flex {
					display: flex;
					justify-content: center;
				}

				.day-number-flex {
					display: inline-block;
					width: 14.28%;
					text-align: center;
				}

				.every-meeting {
					font-size: 14px;
					color: white;
					line-height: 22px;

					.line-1 {
						white-space: nowrap;
						/* 不换行 */
						overflow: hidden;
						/* 内容超出宽度时隐藏超出部分的内容 */
						text-overflow: ellipsis;
						/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
						margin-bottom: 5px;
						padding: 0 5px;
						flex: 1;
					}
				}
			}
		}
	}
}

h2 {
	font-size: 15px;
	text-align: center;
	line-height: 60px;
	color: #141414;
	font-weight: normal;
}

.detail-item {
	display: flex;
	margin: 10px 15px 30px;

	.color-line {
		background: #4B85ED;
		width: 5px;
		// height: 91px;
		display: inline-block;
		border-radius: 2.5px;
		margin-right: 15px;
	}

	img {
		width: 100%;
		border-radius: 0.2rem;

	}

	.image {
		width: 35%;
		margin: 0 0 0 4%;
	}

	.content {
		width: 61%;
		position: relative;
		font-size: 14px;
		padding: 5px 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		min-height: 100px;

		p {
			// position: absolute;
			// bottom: 25px;

			font-size: 12px;
			line-height: 14px;
			color: #666666;
		}
	}
}

@media screen and (min-width:1000px) {
	h2 {
		line-height: 40px;
		color: #141414;
		font-weight: normal;
	}

	.detail-item {
		margin: 10px 15px 20px;

		.image {
			width: 20%;
			margin: 0 0 0 4%;
		}

		.content {
			width: 70%;

			p {
				position: relative;
				margin-bottom: 4px;
			}
		}

	}


}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Calendar.vue